<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        Exception
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Hash</a>
          </li>
      </ul>
    </div>
    <b-card>
      <b-row>
        <b-col>
          Exception List
        </b-col>
      </b-row>
      <hr>
      <b-card v-show="so.adv">
        <b-row>
          <b-col>
            <b-form-group label="Usage status">
              <b-form-radio-group id="radio-group-2" v-model="so.opt.is_alive" v-b-tooltip.hover title="Please enter the Usage Status you want to search for">
                <b-form-radio :value="true" @click="so.sv=`is_alive`">Used</b-form-radio>
                <b-form-radio :value="false" @click="so.sv=`is_alive`">Disable</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="MD5" label-for="ph_code" v-b-tooltip.hover title="Please enter the MD5 you want to search for">
              <b-form-input v-model="so.sv" @click="so.sk='md5';"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            Registration From
            <b-form>
              <date-picker :lang="custom.lang.en" v-model="so.opt.created_at_sd" style="width: 60%" :confirm="true" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="4">
            Registration To
            <b-form>
              <date-picker :lang="custom.lang.en" v-model="so.opt.created_at_ed" style="width: 60%" :confirm="true" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh" > Search </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="default" @click="so.adv = false"> Cancel </b-button>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col sm="6">
          <!-- <b-pagination size="sm" :limit="5" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"/> -->
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-input-group-text size="sm" variant="outline-secondary">MD5</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" v-show="!so.adv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary"  @click="so.adv = true"><i :class="'fa ' + (so.adv ? 'fa-search-minus' : 'fa-search-plus')"> Detail Search</i></b-btn>
              <b-btn variant="outline-secondary" v-show="so.adv" @click="so.adv = false"><i class="fa fa-search-minus"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="hash" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.hash}}
          </a>
        </template>
        <template slot="cause" slot-scope="row">{{row.item.cause}}</template>
        <template slot="created_at" slot-scope="row">
          {{row.item.created_at | date}}
        </template>
        <template slot="is_alive" slot-scope="row">
          <b-badge v-if="row.item.is_alive == true" variant="success">Used</b-badge>
          <b-badge v-else>Disable</b-badge>
        </template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col md="3"></b-col>
        <b-col md="5">
          <b-pagination size="sm"  align="center":limit="5" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"/>
        </b-col>
        <b-col md="4">
          <div class="pull-right">
            <b-button class="btn-add" size="sm" variant="success" @click="$router.push({ name: 'wsfinder_hash', params: { id : 'add' }})"> New registration </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
